import { render, staticRenderFns } from "./DeliveriesChangeDriverForm.vue?vue&type=template&id=4298b859&lang=pug&"
import script from "./DeliveriesChangeDriverForm.vue?vue&type=script&lang=js&"
export * from "./DeliveriesChangeDriverForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports